import React from "react";
import { Typography, Tag, Drawer, Row, Col, Tooltip, Table, Button } from "antd";
import NumberFormat from "react-number-format";
import PriceAdjustTag from "./PriceAdjustTag";
import { FONT } from "../styles/typography";
import { adjustColor } from "./priceAdjust";
import { priceDetailDrawerState } from "../../controller/stores";
import { toJS } from "mobx";
import { Observer, observer } from "mobx-react";
import { setPriceDetailDrawerVisible } from "../../controller/actions";
import PriceDetailDrawer from "./PriceDetailDrawer";
import moment from "moment";
import "moment/locale/zh-tw";
import { buildRankingRows, isStale } from "./rankingRows";
class RankingDetailDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detailDrawer: false,
      detailRows: []
    };
  }
  onShowDetailDrawer = (record, rowIndex, e) => {
    this.setState({
      detailDrawer: true,
      detailRows: record.details,
    })
  };
  onHideDetailDrawer = () => {
    this.setState({
      detailDrawer: false,
    })
  };
  onHandleClose = () => {
    setPriceDetailDrawerVisible(false, null, null);
  };
  render() {
    let priceData = toJS(priceDetailDrawerState.priceData);
    let rank = toJS(priceDetailDrawerState.rank);
    const now = Date.now();
    const rows = buildRankingRows(rank, priceData ? priceData.recommendprice : null);

    const columns = [
      {
        // 這欄一直都是 hotels.rank 飯店等級，與新的價格排序是兩回事，
        // 沿用「排名」當標題會被誤讀成價格名次
        title: "等級",
        width: 60,
        dataIndex: "hotel_rank",
        render: (value) => (value === null || value === undefined ? "—" : value),
      },
      {
        title: "飯店",
        width: 220,
        dataIndex: "label",
        render: (value, record) =>
          record.isDisabled ? (
            <span>
              {value} <Tag>已停用</Tag>
            </span>
          ) : (
            value
          ),
      },
      {
        title: "平均價格",
        dataIndex: "averageprice",
        width: 120,
        render: (price) => (
          <NumberFormat
            value={Math.ceil(price)}
            displayType="text"
            thousandSeparator={true}
            fixedDecimalScale={true}
          />
        ),
      },
      {
        title: "樣本數",
        width: 90,
        dataIndex: "count",
        render: (value) => (value === null || value === undefined ? "—" : value),
      },
      {
        title: "最後更新",
        width: 160,
        dataIndex: "last_updated_at",
        render: (value) => {
          if (!value) return "—";
          const stale = isStale(value, now);
          return (
            <Tooltip title={value}>
              <span style={stale ? { color: "#F2994A" } : undefined}>
                {moment(value).fromNow()}
                {stale ? " ⚠" : ""}
              </span>
            </Tooltip>
          );
        },
      },
      {
        title: "明細",
        width: 100,
        render: (text, record, index) =>
          record.isRecommend ? null : (
            <Button onClick={(e) => this.onShowDetailDrawer(record, index, e)}>明細</Button>
          ),
      },
    ];

    return (
      <Observer>
        {() => (
          <div>
            <PriceDetailDrawer 
            visible={this.state.detailDrawer} 
            details={this.state.detailRows}
            onClose={this.onHideDetailDrawer} />
            <Drawer
              visible={priceDetailDrawerState.visible}
              onClose={this.onHandleClose}
              width={800}
              zIndex={99999999}
            >
              {priceData === null ? null : (
                <>
                  <div style={{ padding: "10px 0" }}>
                    <Row gutter={[16, 16]}>
                      <Col>禾風新棧</Col>
                      <Col>
                        {priceData.category === "twin" ? (
                          <Tag>兩小床</Tag>
                        ) : priceData.category === "double" ? (
                          <Tag>一大床</Tag>
                        ) : priceData.category === "twin-double" ? (
                          <Tag>兩大床</Tag>
                        ) : priceData.roomcategory === "quad" ? (
                          <Tag>四小床</Tag>
                        ) : priceData.roomcategory === "family" ? (
                          <Tag>家庭房</Tag>
                        ) : (
                          <Tag>總統套房</Tag>
                        )}
                        <Tag>{priceData.pricetype_name}</Tag>
                      </Col>
                    </Row>
                    <Row
                      gutter={[16, 16]}
                      justify="space-between"
                      align="middle"
                      style={{
                        background: "#F2F2F2",
                        borderRadius: 10,
                        padding: 10,
                      }}
                    >
                      <Col>
                        <Typography.Title level={3} style={{ margin: 0 }}>
                          建議價格
                        </Typography.Title>
                      </Col>
                      <Col>
                        <Row>
                          <Col>
                            <Tooltip title="目前價格">
                              <Typography.Text delete>
                                {
                                  <NumberFormat
                                    value={priceData.currentprice}
                                    displayType="text"
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                  />
                                }
                              </Typography.Text>
                            </Tooltip>
                          </Col>
                        </Row>
                        <Row align="middle">
                          <Col>
                            <Tooltip title="建議價格">
                              <Typography.Text
                                strong
                                style={{
                                  fontSize: FONT.title,
                                  color: adjustColor(priceData.priceadjustrate),
                                }}
                              >
                                <NumberFormat
                                  value={priceData.recommendprice}
                                  displayType="text"
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                />
                              </Typography.Text>
                            </Tooltip>
                          </Col>
                          <Col>
                            <PriceAdjustTag
                              amount={priceData.priceadjust}
                              rate={priceData.priceadjustrate}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                      <Col>選取日期</Col>
                      <Col>{priceData.dates.join(" 、 ")}</Col>
                    </Row>
                  </div>
                  <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={rows}
                    rowKey="hotel_id"
                    size="small"
                    pagination={false}
                    onRow={(record) => ({
                      style: record.isRecommend
                        ? { background: "#FFF7E6", fontWeight: 600 }
                        : record.isDisabled
                        ? { color: "#BFBFBF" }
                        : undefined,
                    })}
                  />
                </>
              )}
            </Drawer>
          </div>
        )}
      </Observer>
    );
  }
}
export default observer(RankingDetailDrawer);
